import { useEffect, useState, useContext } from "react";
import BTBox from "../../components/BTBox";
import BTTypography from "../../components/BTTypography";
import BTDivider from "../../components/BTDivider";
import BTInput from "../../components/BTInput";
import DashboardLayout from "../../Layouts/Layoutcontainers";
import { Grid2 as Grid, Card, TextField, Autocomplete } from "@mui/material";
import CountUp from "react-countup";
import { Error } from "@mui/icons-material";
import { useLoading, useNotification } from "../../context";
import { useDispatch, useSelector } from "react-redux";
import EnhancedTable from "../../components/BTTable";
import BTBadge from "../../components/BTBadge";
import { stone_status } from "../../dropdownData";
import { get_sizes, get_parties, get_services } from "../../store/functions";
import GlobalAutoComplete from "./Globalsearch";
import moment from "moment/moment";
import secureLocalStorage from "react-secure-storage";
import authService from "../../services/auth-service";
import { manage_store_data } from "../../store/functions";
import { additional_services } from "../../dropdownData";
import { get } from "../../store/labSlice";
import { fetchData } from "../../utils/fetchData";
const StatCard = ({
  title,
  value,
  color = "grey-300",
  onClick,
  dataKey,
  statusId,
  size = { xs: 12, md: 4 },
  activeCard,
  setFilterTitle,
  setSearch,
  setActiveCard,
  setLoading,
  clearState,
}) => {
  const isActive = activeCard === dataKey;

  const handleClick = () => {
    if (!onClick || isActive) return;
    const now = moment();
    const today = now.format("YYYY-MM-DD");
    let startDate, endDate;
    if (now.date() >= 26) {
      startDate = now.clone().date(26).format("YYYY-MM-DD");
      endDate = now.clone().add(1, "month").date(25).format("YYYY-MM-DD");
    } else {
      startDate = now
        .clone()
        .subtract(1, "month")
        .date(26)
        .format("YYYY-MM-DD");
      endDate = now.clone().date(25).format("YYYY-MM-DD");
    }

    setLoading(true);
    setFilterTitle(title);
    const delayKeys = ["late_submits", "late_results", "late_replies"];
    const dailyKeys = ["daily_count", "lab_out_daily_count"];
    const monthlyKeys = ["current_month_count", "lab_out_current_month_count"];
    const submitMonthlyKeys = ["submits_monthly"];
    const laboutMonthlyKeys = ["labouts_monthly"];
    const colorKey = ["color_count"];
    const isDelay = delayKeys.includes(dataKey);
    const isDaily = dailyKeys.includes(dataKey);
    const isMonthly = monthlyKeys.includes(dataKey);
    const isSubmitMonthly = submitMonthlyKeys.includes(dataKey);
    const isLaboutMonthly = laboutMonthlyKeys.includes(dataKey);
    const isColor = colorKey.includes(dataKey);
    clearState();
    setSearch((prev) => ({
      ...prev,
      status: isDelay ? null : statusId,
      page: 1,
      is_delay: isDelay,
      which_delay: isDelay ? dataKey.replace("late_", "") : null,
      from_date: isDaily
        ? today
        : isMonthly || isSubmitMonthly || isLaboutMonthly
        ? startDate
        : null,
      to_date: isDaily
        ? today
        : isMonthly || isSubmitMonthly || isLaboutMonthly
        ? endDate
        : null,
      additional_services: isColor ? ["color"] : null,
    }));

    setActiveCard(dataKey);
  };
  const activeStyle = {
    boxShadow: "0 0 10px rgba(23, 30, 37, 0.5)",
  };
  return (
    <Grid size={size}>
      <BTBox
        bgColor={color}
        borderRadius="md"
        pl={1}
        onClick={handleClick}
        sx={{
          cursor: onClick ? "pointer" : "default",
          ...(isActive ? activeStyle : {}),
          transition: "all 0.2s ease", // Smooth transition for hover effects
          "&:hover": {
            boxShadow: onClick ? activeStyle : "none", // Shadow on hover
          },
        }}>
        <BTTypography fontWeight={"bold"} variant="caption">
          {title}
        </BTTypography>
        <BTTypography fontWeight={"bold"} variant="h6">
          <CountUp end={value} duration={1} />
        </BTTypography>
      </BTBox>
    </Grid>
  );
};

// Dashboard cards
const SubmmissionCard = ({
  deshboardCount,
  activeCard,
  setFilterTitle,
  setSearch,
  setLoading,
  setActiveCard,
  clearState,
}) => (
  <Grid size={{ xs: 12, md: 6, lg: 3 }}>
    <BTBox
      bgColor={"white"}
      borderRadius="md"
      shadow="sm"
      width="100%"
      height={"400px"}
      overflow="auto"
      p={2}>
      <BTTypography
        variant="h6"
        color={"text"}
        fontWeight={"bold"}
        textTransform={"uppercase"}>
        submission
      </BTTypography>
      <BTDivider my={1} />
      <Grid container spacing={1}>
        <StatCard
          title="Total"
          statusId={null}
          value={deshboardCount["grand_total_count"]}
          dataKey="grand_total_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Monthly"
          value={deshboardCount["current_month_count"]}
          dataKey="current_month_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Today"
          value={deshboardCount["daily_count"]}
          dataKey="daily_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Delayed"
          value={deshboardCount["late_submits"]}
          color="error"
          dataKey="late_submits"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Color"
          value={deshboardCount["color_count"]}
          dataKey="color_count"
          color="warning"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Normal"
          value={deshboardCount["normal_count"]}
          statusId={[1]}
          dataKey="normal_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Certy Recheck"
          value={deshboardCount["certy_recheck_count"]}
          dataKey="certy_recheck_count"
          statusId={[10]}
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Recut"
          value={deshboardCount["recut_count"]}
          dataKey="recut_count"
          statusId={[5]}
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Ungraded"
          value={deshboardCount["ungraded_return_count"]}
          dataKey="ungraded_return_count"
          statusId={[15]}
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="On hand total"
          value={deshboardCount["on_hand_total_submission_count"]}
          size={{ xs: 12, md: 12 }}
          dataKey={"on_hand_total_submission_count"}
          statusId={[1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 14, 15]}
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
      </Grid>
    </BTBox>
  </Grid>
);

const ResultsCard = ({
  deshboardCount,
  activeCard,
  setFilterTitle,
  setSearch,
  setLoading,
  setActiveCard,
  clearState,
}) => (
  <Grid size={{ xs: 12, md: 6, lg: 3 }}>
    <BTBox
      bgColor={"white"}
      borderRadius="md"
      shadow="sm"
      width="100%"
      height={"400px"}
      overflow="auto"
      p={2}>
      <BTTypography
        variant="h6"
        color={"text"}
        fontWeight={"bold"}
        textTransform={"uppercase"}>
        results
      </BTTypography>
      <BTDivider my={1} />
      <Grid container spacing={1}>
        <StatCard
          title="Results"
          value={deshboardCount["total_result_count"]}
          statusId={[2, 4, 6, 11]}
          dataKey="total_result_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Recheck"
          value={deshboardCount["recheck_count"]}
          statusId={[3]}
          dataKey="recheck_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Delayed"
          value={deshboardCount["late_results"]}
          color="error"
          dataKey="late_results"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Results ok"
          statusId={[8]}
          color="success"
          value={deshboardCount["result_ok_count"]}
          dataKey="result_ok_count"
          onClick={true}
          size={{ xs: 12, md: 12 }}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
      </Grid>
    </BTBox>
  </Grid>
);

const RepliesCard = ({
  deshboardCount,
  activeCard,
  setFilterTitle,
  setSearch,
  setLoading,
  setActiveCard,
  clearState,
}) => (
  <Grid size={{ xs: 12, md: 6, lg: 3 }}>
    <BTBox
      bgColor={"white"}
      borderRadius="md"
      shadow="sm"
      width="100%"
      height={"400px"}
      overflow="auto"
      p={2}>
      <BTTypography
        variant="h6"
        color={"text"}
        fontWeight={"bold"}
        textTransform={"uppercase"}>
        replied
      </BTTypography>
      <BTDivider my={1} />
      <Grid container spacing={1}>
        <StatCard
          title="Pending"
          value={deshboardCount["pendding_count"]}
          statusId={[8]}
          dataKey="pendding_count"
          onClick={true}
          size={{ xs: 12, md: 6 }}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Delayed"
          value={deshboardCount["late_replies"]}
          color="error"
          dataKey="late_replies"
          onClick={true}
          size={{ xs: 12, md: 6 }}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Ready for delivery"
          color="success"
          value={deshboardCount["ready_for_delivery_count"]}
          statusId={[8]}
          dataKey="ready_for_delivery_count"
          onClick={true}
          size={{ xs: 12, md: 12 }}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
      </Grid>
    </BTBox>
  </Grid>
);

const ReturnsCard = ({
  deshboardCount,
  activeCard,
  setFilterTitle,
  setSearch,
  setLoading,
  setActiveCard,
  clearState,
}) => (
  <Grid size={{ xs: 12, md: 6, lg: 3 }}>
    <BTBox
      bgColor={"white"}
      borderRadius="md"
      shadow="sm"
      height="400px"
      overflow="auto"
      width="100%"
      p={2}>
      <BTTypography
        variant="h6"
        color={"text"}
        fontWeight={"bold"}
        textTransform={"uppercase"}>
        Lab Out
      </BTTypography>
      <BTDivider my={1} />
      <Grid container spacing={1}>
        <StatCard
          title="Total"
          value={deshboardCount["lab_out_total_count"]}
          statusId={[9, 12, 13, 15]}
          dataKey="lab_out_total_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Monthly"
          value={deshboardCount["lab_out_current_month_count"]}
          dataKey="lab_out_current_month_count"
          statusId={[9, 12, 13, 15]}
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Today"
          value={deshboardCount["lab_out_daily_count"]}
          statusId={[9, 12, 13, 15]}
          dataKey="lab_out_daily_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Delivery pending"
          value={deshboardCount["delivery_pending_count"]}
          statusId={[12]}
          dataKey="delivery_pending_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Delivered"
          value={deshboardCount["delivered_count"]}
          statusId={[13]}
          dataKey="delivered_count"
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Ungraded"
          value={deshboardCount["ungraded_return_count"]}
          dataKey="ungraded_return_count"
          statusId={[15]}
          onClick={true}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
        <StatCard
          title="Total labout on hand"
          value={deshboardCount["total_hand_on_count"]}
          dataKey="total_hand_on_count"
          statusId={[9]}
          onClick={true}
          size={{ xs: 12, md: 12 }}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setActiveCard={setActiveCard}
          setLoading={setLoading}
          clearState={clearState}
        />
      </Grid>
    </BTBox>
  </Grid>
);
const Deskboard = () => {
  const { u_id, u_type, parent_u_id, admin_u_id } =
    secureLocalStorage.getItem("userdata");
  const dispatch = useDispatch();
  const sizes = useSelector((state) => state?.lab?.sizes);
  const parties = useSelector((state) => state?.lab?.parties);
  const services = useSelector((state) => state?.lab?.services);
  const submission = useSelector((state) => state?.lab?.submission);
  const { showLoading, hideLoading } = useLoading();
  const { addNotification } = useNotification();
  const [filterTitle, setFilterTitle] = useState("All Submissions");
  const [activeCard, setActiveCard] = useState(null);
  const [deshboardCount, setDeshBoardCount] = useState({});
  const [search, setSearch] = useState({
    type: 2,
    p_id: null,
    from_date: moment().startOf("year").format("YYYY-MM-DD"),
    to_date: moment().add(1).format("YYYY-MM-DD"),
    rowsPerPage: 50,
    page: 1,
    searchText: null,
    last_id: 0,
    status: null,
    p_stn_id: null,
    additional_services: null,
  });
  const [loading, setLoading] = useState(false);
  const [localDates, setLocalDates] = useState({
    from_date: search?.from_date || "",
    to_date: search?.to_date || "",
  });
  let pageIndex = submission?.pages?.findIndex((p) => p.page === search.page);
  const startIndex = pageIndex !== -1 ? pageIndex * search.rowsPerPage : 0;
  const endIndex = startIndex + search.rowsPerPage;
  // Card component with click handler
  useEffect(() => {
    !sizes?.is_fetch && get_sizes();
    !parties?.is_fetch && get_parties();
    !services?.is_fetch && get_services();
  }, [search]);
  useEffect(() => {
    fetchSubmission();
  }, [search]);
  useEffect(() => {
    getStatistics();
  }, []);
  const fetchSubmission = async () => {
    const response = await fetchData({
      api: "get_submissions",
      name: "submission",
      key: "stn_id",
      searchParams: search,
      filterCallback: handleSearch,
      showLoading: () => setLoading(true),
      hideLoading: () => setLoading(false),
      hold: true,
    });
    if (!response?.status) {
      addNotification({
        title: "#Error",
        message: response?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    }
  };
  const handleSearch = (data, searchData) => {
    const filterBySearch = data?.filter((item) => {
      const searchText = searchData?.searchText?.toLowerCase().trim() || "";
      const matchText =
        item?.stn_desc?.toLowerCase()?.includes(searchText) ||
        String(item?.sub_count)?.toLowerCase()?.includes(searchText) ||
        String(item?.sub_weight)?.toLowerCase()?.includes(searchText);
      const matchFilters =
        item?.stn_type === searchData?.type &&
        (searchData?.p_id ? item?.p_id === searchData?.p_id : true) &&
        searchData?.status?.includes(item?.stn_status);
      moment(item.stn_date, "YYYY-MM-DD").isBetween(
        moment(searchData?.from_date, "YYYY-MM-DD").startOf("day"),
        moment(searchData?.to_date, "YYYY-MM-DD").endOf("day"),
        null,
        "[]"
      );
      return matchText && matchFilters;
    });
    const paginateData = filterBySearch?.slice(startIndex, endIndex);
    return paginateData;
  };
  const getStatistics = async () => {
    try {
      showLoading();
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const response = await authService?.dashboard_statistics({
        attributes: {
          u_id,
          u_type,
          parent_u_id,
          admin_u_id: u_type === 1 ? u_id : admin_u_id,
        },
      });
      if (response?.status === 1) {
        setDeshBoardCount(response?.data);
      }
    } catch (error) {
      addNotification({
        message: error?.message || "Something went wrong",
        type: "error",
        color: "error",
        icon: <Error fontSize="small" color="white" />,
      });
    } finally {
      hideLoading();
    }
  };
  const handleDateChange = (field, value) => {
    const newDates = { ...localDates, [field]: value };
    setLocalDates(newDates);
    const timer = setTimeout(() => {
      clearState();
      setSearch({
        ...search,
        from_date: newDates.from_date,
        to_date: newDates.to_date,
        page: 1,
      });
    }, 500);

    return () => clearTimeout(timer);
  };
  const clearState = () => {
    dispatch(
      get({
        name: "submission",
        data: [],
        pages: [],
        total: 0,
        fetch: false,
      })
    );
  };
  const columns = [
    {
      id: "id",
      name: "ID",
      value: (row, index) => row?.stn_id,
      selector: (row, index) => index + 1,
      width: "50px",
      numeric: false,
      sortable: true,
    },
    {
      id: "stn_prefix_ref_no",
      name: "Prefix No",
      selector: (row) => row?.stn_prefix_ref_no,
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_cus_ref_no",
      name: "Customer Ref No",
      selector: (row) => row?.stn_cus_ref_no,
      width: "80px",
      sortable: true,
    },
    {
      id: "p_name",
      name: "Party",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_name;
      },
      width: "100px",
      sortable: true,
    },
    {
      id: "p_code",
      name: "Party code",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_code;
      },
      width: "80px",
      sortable: true,
    },
    {
      id: "stn_pcs",
      name: "Pcs",
      selector: (row) => row?.stn_pcs,
      width: "50px",
      sortable: true,
    },
    {
      id: "stn_cts",
      name: "Weight",
      selector: (row) => Number(row?.stn_cts)?.toFixed(2),
      width: "50px",
      sortable: true,
    },
    {
      id: "size",
      name: "Size",
      selector: (row) => {
        const weight = row?.stn_cts;
        const size = sizes?.data?.find(
          ({ size_from, size_to }) => weight >= size_from && weight <= size_to
        );
        if (size) {
          return `${Number(size?.size_from)?.toFixed(2)} - ${Number(
            size?.size_to
          )?.toFixed(2)}`;
        } else {
          return "-";
        }
      },
      width: "80px",
    },
    {
      id: "stn_services",
      name: "Services",
      selector: (row) => {
        return row?.stn_services?.map((item) => item.ser_name).join(", ") || "";
      },
      width: "70px",
    },
    {
      id: "aditional_services",
      name: "Aditional Services",
      selector: (row) => {
        let services = [];
        if (row?.stn_without_plot) {
          services?.push("Without Plotting");
        }
        if (row?.stn_tatkal) {
          services?.push("Tatkal");
        }
        if (row?.stn_color) {
          services?.push("Color");
        }
        return services?.join(",");
      },
      width: "70px",
    },
    {
      id: "stn_date",
      name: "Date",
      selector: (row) =>
        moment(row?.stn_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY"),
      width: "100px",
    },
    {
      id: "stn_status",
      name: "Status",
      value: (row) => {
        const name = stone_status?.find(
          ({ value }) => value === row?.stn_status
        )?.label;
        return name;
      },
      selector: (row) => {
        const name = stone_status?.find(
          ({ value }) => value === row?.stn_status
        )?.label;
        return (
          <BTBadge badgeContent={name} size="xs" container color="success" />
        );
      },
      width: "100px",
      sortable: true,
    },
    {
      id: "stn_desc",
      name: "Description",
      selector: (row) => row?.stn_desc,
      width: "100px",
    },
  ];

  return (
    <DashboardLayout>
      <Grid container spacing={2} width={"100%"} mb={2}>
        <SubmmissionCard
          deshboardCount={deshboardCount}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setLoading={setLoading}
          setActiveCard={setActiveCard}
          clearState={clearState}
        />
        <ResultsCard
          deshboardCount={deshboardCount}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setLoading={setLoading}
          setActiveCard={setActiveCard}
          clearState={clearState}
        />
        <RepliesCard
          deshboardCount={deshboardCount}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setLoading={setLoading}
          setActiveCard={setActiveCard}
          clearState={clearState}
        />
        <ReturnsCard
          deshboardCount={deshboardCount}
          activeCard={activeCard}
          setFilterTitle={setFilterTitle}
          setSearch={setSearch}
          setLoading={setLoading}
          setActiveCard={setActiveCard}
          clearState={clearState}
        />
        <Grid item size={{ xs: 12, md: 3 }}>
          <GlobalAutoComplete />
        </Grid>
        <Grid item size={{ xs: 12, md: 9 }}>
          <Card sx={{ mb: 1, p: 2 }}>
            <BTBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{
                flexDirection: { xs: "column", sm: "row" },
                alignItems: { xs: "flex-start", sm: "center" },
                gap: 1,
              }}>
              <BTBox
                display="flex"
                alignItems="center"
                sx={{
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: { xs: "flex-start", sm: "center" },
                  gap: 2,
                  width: { xs: "100%", sm: "auto" },
                }}>
                <Autocomplete
                  options={parties?.data || []}
                  getOptionLabel={(option) =>
                    `${option.p_code} : ${option.p_name}` || ""
                  }
                  renderOption={(props, option) => (
                    <li {...props}>{`${option.p_code} : ${option.p_name}`}</li>
                  )}
                  onChange={(event, value) => {
                    clearState();
                    setSearch({ ...search, p_id: value?.p_id, page: 1 });
                  }}
                  sx={{ width: "100%" }}
                  value={
                    parties?.data?.find(({ p_id }) => p_id === search?.p_id) ||
                    null
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Party"
                      size="small"
                      variant="standard"
                      sx={{ width: { xs: "100%", sm: "200px" } }}
                    />
                  )}
                />

                <Autocomplete
                  options={sizes?.data || []}
                  getOptionLabel={(option) =>
                    `${option?.size_from} - ${option?.size_to}`
                  }
                  sx={{ width: "100%" }}
                  multiple={true}
                  onChange={(event, value) => {
                    clearState();
                    setSearch({
                      ...search,
                      sizes: value?.map(({ size_id }) => size_id) || null,
                      page: 1,
                    });
                  }}
                  value={
                    sizes?.data?.filter(({ size_id }) =>
                      search?.sizes?.includes(size_id)
                    ) || []
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Size"
                      size="small"
                      variant="standard"
                      sx={{ width: { xs: "100%", sm: "150px" } }}
                    />
                  )}
                />

                <Autocomplete
                  options={services?.data || []}
                  getOptionLabel={(option) => option?.ser_name || ""}
                  value={
                    services?.data?.filter(
                      ({ ser_id }) => search?.services?.includes(ser_id) || null
                    ) || []
                  }
                  onChange={(event, value) => {
                    clearState();
                    setSearch({
                      ...search,
                      services: value?.map(({ ser_id }) => ser_id) || null,
                      page: 1,
                    });
                  }}
                  sx={{ width: "100%" }}
                  multiple={true}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="service"
                      size="small"
                      variant="standard"
                      sx={{ width: { xs: "100%", sm: "150px" } }}
                    />
                  )}
                />

                <Autocomplete
                  options={additional_services || []}
                  getOptionLabel={(option) => option?.label || ""}
                  value={
                    additional_services?.filter(
                      ({ value }) =>
                        search?.additional_services?.includes(value) || null
                    ) || []
                  }
                  onChange={(event, value) => {
                    clearState();
                    setSearch({
                      ...search,
                      additional_services:
                        value?.map(({ value }) => value) || null,
                      page: 1,
                    });
                  }}
                  sx={{ width: "100%" }}
                  multiple={true}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Additional service"
                      size="small"
                      variant="standard"
                      sx={{ width: { xs: "100%", sm: "150px" } }}
                    />
                  )}
                />
                <BTInput
                  size="small"
                  type="date"
                  label="From Date"
                  value={localDates.from_date}
                  onChange={(e) =>
                    handleDateChange("from_date", e.target.value)
                  }
                  variant="standard"
                  sx={{ width: "100%" }}
                />

                <BTInput
                  size="small"
                  type="date"
                  label="To Date"
                  value={localDates.to_date}
                  onChange={(e) => handleDateChange("to_date", e.target.value)}
                  variant="standard"
                  sx={{ width: "100%" }}
                />
              </BTBox>
            </BTBox>
          </Card>
          <EnhancedTable
            rows={submission?.data.slice(startIndex, endIndex)}
            columns={columns}
            tableHeader={true}
            pagination={true}
            title={filterTitle}
            loading={loading}
            serverSidePagination={true}
            serverSideSearch={true}
            fetchData={{
              fnc: fetchData,
              params: {
                api: "get_submissions",
                searchParams: {
                  ...search,
                  page: 1,
                  rowsPerPage: submission?.total,
                },
                filterCallback: null,
                name: "submission",
                key: "stn_id",
                showLoading,
                hideLoading,
                hold: false,
              },
            }}
            totalRows={submission?.total}
            onPageChange={({ page, rowsPerPage, searchText }) => {
              if (search?.rowsPerPage !== rowsPerPage) {
                clearState();
              }
              setSearch({
                ...search,
                page,
                rowsPerPage,
                searchText,
                last_id: submission?.pages[pageIndex]?.next_last_id,
              });
            }}
            onSearchChange={(searchText, { page, rowsPerPage }) => {
              clearState();
              setSearch((prev) => ({ ...prev, searchText, page, rowsPerPage }));
            }}
            initialPage={search?.page}
            sx={{ height: "350px" }}
          />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default Deskboard;
